export default __webpack_public_path__ + "static/media/MusicAvatar.11e4bd14.svg";